(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ml-per-page"] && !Shopify.designMode) return;
  try {
    // Keep the current filters and sort when changing the page size, and start again at page 1.
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-ml-perpage]') : null;
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    const url = new URL(window.location.href);
    const size = link.getAttribute('data-ml-perpage');
    if (size === '20') {
      url.searchParams.delete('view');
    } else {
      url.searchParams.set('view', size);
    }
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    window.location.assign(url.toString());
  });
  } catch(e) { console.error(e); }
})();

})();
